import { Button, DataSource, HorizontalSpacer, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutRapidAlertSlideout extends Layout {
    buttonConfirmedSelected: Button;
    buttonExpandAll: Button;
    horizontalspacer1: HorizontalSpacer;
    panelAccordions: Panel;
    sourceRapidAlert: DataSource;
}
